export abstract class BaseContent {
  index: string[] = [];
  columns: string[] = [];
  dtypes: { [key: string]: string } = {};
  data: { [key: string]: any } = {};
}

export class DataFrameContent extends BaseContent {}
